/**
 * Premium Reveal Animations
 * Uses IntersectionObserver for smooth scroll reveals
 */

class RevealAnimations {
  constructor() {
    this.threshold = 0.1;
    this.observer = null;
    this.init();
  }

  init() {
    // Check for reduced motion preference
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('reveal-active');
          // Once animated, stop observing
          this.observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: this.threshold,
      rootMargin: '0px 0px -50px 0px'
    });

    this.observeElements();

    // Re-observe if sections are dynamically loaded (Shopify Theme Editor)
    document.addEventListener('shopify:section:load', () => this.observeElements());
  }

  observeElements() {
    const revealElements = document.querySelectorAll('[data-reveal]:not(.reveal-active)');
    revealElements.forEach(el => {
      const delay = el.getAttribute('data-reveal-delay');
      if (delay) {
        el.style.transitionDelay = `${delay}ms`;
      }
      this.observer.observe(el);
    });
  }
}

// Initialize on DOM load
document.addEventListener('DOMContentLoaded', () => {
  new RevealAnimations();
});
